module.exports = __webpack_public_path__ + "static/media/aboutus1.1c1b2a45.svg";